import { gql } from '@apollo/client';

export const CREATE_FEEDBACK_SURVEY = gql`
  mutation CreateFeedbackSurvey($input: CreateFeedbackSurveyInput!) {
    createFeedbackSurvey(input: $input) {
      id
    }
  }
`;
